import React from "react";
import decodeLocationSlug from "../../../utils/decode-location-slug";
import { getPropertySearchUrl } from "../../../utils/property-search";
// import ISPRAVA_BUILT_LOGO from "../../assets/logo/isprava-built.webp";
import { useCarouselScroller } from "../../hooks/use-carousel";
import useClx from "../../hooks/use-clx";
import { Track } from "../AnalyticsManager";
import Carousel from "../Carousel";
import Item from "../Carousel/Item";
import NetworkImg from "../NetworkImg";
import Scroller from "../Scroller";
import clxs from "./recommendation.module.css";
import { useQueryParamValue } from "../../hooks/use-query-param";
import RatingCounts from "../PropertyDetail/RatingCounts";
import CHEVRON_RIGHT_GREY from "../../assets/icons/chevron-right-grey.svg";
import LUMA_LOGO from "../../assets/logo/luma-logo.svg";
import useIsMobile from "../../hooks/use-is-mobile";

interface RecommendationProps {
  carouselId: string;
  properties?: PropertyItem[];
  title: string;
  subtitle?: string;
  className?: string;
  checkinDateKey?: string; 
  checkoutDateKey?: string;
  adultCountKey?: string;
  childCountKey?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  containerClassName?: string;
  tracking?: string;
  isSimilarClusters?:boolean;
  simliarClusters?: ClusterSimilarProperty[];
}

function Recommendation(props: RecommendationProps) {
  const {
      carouselId,
      properties,
      simliarClusters,
      title,
      subtitle,
      className,
      checkinDateKey,
      checkoutDateKey,
      adultCountKey,
      childCountKey,
      titleClassName,
      subtitleClassName,
      // containerClassName,
      tracking = "recommendation",
      isSimilarClusters,
    } = props, 
    { scrollLeft, scrollRight ,leftCount, rightCount} = useCarouselScroller(carouselId),
    scx = useClx(clxs.section, className),
    tcx = useClx(titleClassName, clxs.placeholder),
    sucx = useClx(subtitleClassName, clxs.placeholder),
    { isMobile } = useIsMobile(),
    // ccx = useClx(clxs.carousel, containerClassName),
    checkinDate = useQueryParamValue("date", checkinDateKey || "") ,
    checkoutDate = useQueryParamValue("date", checkoutDateKey || ""),
    adultCount = useQueryParamValue("integer", adultCountKey || ""),
    childCount = useQueryParamValue("integer", childCountKey || "");
    //isDatePresent = !!(checkinDate && checkoutDate);

    const getPropertyUrl = ({
      property_slug,
      location_slug,
      offering_type_ids,
      isSimilarClusters,
    }: {
      property_slug: string;
      location_slug: string;
      offering_type_ids?: number[];
      isSimilarClusters?: boolean;
    }): string => {
      const locationUrl = getPropertySearchUrl(
        location_slug,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        isSimilarClusters,
      );
    
      const updatedSearchParams = new URLSearchParams();

      if (checkinDate) {
        updatedSearchParams.set("checkin_date", checkinDate.toISOString());
      }
    
      if (checkoutDate) {
        updatedSearchParams.set("checkout_date", checkoutDate.toISOString());
      }

      if (adultCount) {
        updatedSearchParams.set("adult_count", adultCount.toString());
      } else {
        updatedSearchParams.set("adult_count", "2"); 
      }
  
      if (childCount !== undefined) {
        updatedSearchParams.set("child_count", childCount.toString());
      }
    
      if (isSimilarClusters && offering_type_ids?.length) {
        updatedSearchParams.set("offering_type_ids", offering_type_ids.join(","));
      }
    
      const queryString = updatedSearchParams.toString();
      return queryString
        ? `${locationUrl}/${property_slug}?${queryString}`
        : `${locationUrl}/${property_slug}`;
    };
    

    const listToRender: (PropertyItem | ClusterSimilarProperty)[] = isSimilarClusters
      ? simliarClusters ?? []
      : properties ?? [];

    if (!listToRender || listToRender.length === 0) {
      return null;
    }

  return (
    <div className={scx}>
      <div className={tcx}>
        {title}
      </div>
      {subtitle && (
        <div className={sucx}>
          {subtitle}
        </div>
      )}
      <Carousel
        id={carouselId}
        className={clxs.carousel}
        threshold={0.9}
        adjust={true}
      >
        {listToRender.map(
          (property, i) => {
            const {
                thumbnail,
                name,
                address,
                rate,
                // isprava_built,
                location_slug,
                property_slug,
                currency_symbol,
                discounted_rate,
                average_ratings,
                ratings_count,
                total_rate,
                cluster_villas_count,
                offering_type_ids,
                brand,
              } = property,
              decodedLocation = decodeLocationSlug(location_slug),
              //locationUrl = getPropertySearchUrl(location_slug, undefined, undefined, undefined, undefined, undefined, isSimilarClusters),
              isShowDiscountedPrice = discounted_rate && (discounted_rate > 0) && (rate >0) && (discounted_rate < rate),
               url = getPropertyUrl({
                property_slug,
                location_slug,
                offering_type_ids,
                isSimilarClusters,
              }),
              finalPrice = discounted_rate || rate;

              const  isLuma =  brand === "lohono_luma";

            return (
              <Item
                key={i}
                className={clxs.item}
              >
                <Track
                  event={tracking}
                  payload={{
                    ...property,
                    ...decodedLocation,
                    href: url,
                    index: i,
                  }}
                >
                  <a
                    href={url}
                    className={isLuma ? `${clxs.property} ${clxs.lumaProperty}`: clxs.property}
                    title={name}
                  >
                    <NetworkImg
                      loading="lazy"
                      src={thumbnail.url}
                      alt={thumbnail.alt}
                      className={clxs.thumbnail}
                      mobileQuality={20}
                      desktopQuality={40}
                      mobileDimensions={[400, 300]}
                      desktopDimensions={[600, 400]}
                    />
                    {isLuma ?
                    <div className={clxs.lumaTag}>
                    <img
                      src={LUMA_LOGO}
                      alt="Lohono Luma"
                      className={clxs.lumalogo}
                    />
                    </div> : null
                    }
                    {(isSimilarClusters && cluster_villas_count)  ? <div className={clxs.villaCount}> {cluster_villas_count} Entire Villa</div> : null}
                    <div className={clxs.title}>
                      {name}
                    </div>
                    <div className={clxs.subtitle}>
                      {address}
                    </div>
                    {/* <div className={ isprava_built ? clxs.logoratingcounts : clxs.ratings}> */}
                    {ratings_count && average_ratings ?
                    <div className={clxs.ratings}>
                      <RatingCounts
                        className={clxs.ratingCounts}
                        ratings_count={ratings_count}
                        average_ratings={average_ratings}
                        theme="recommendationRating"
                      /> 
                    </div>: null }
                    <div className={`${clxs.list} ${clxs.clusterList}`}>

                      {/* Show "Per Villa Price" text if it's a similar cluster */}
                      {isSimilarClusters ? (
                        <div className={clxs.perVilla}>
                          Per Villa Price
                        </div>
                      ) : null}
                      
                      <div className={clxs.priceContainer}>
                        {/* Show "Start from" section only if it's a similar cluster AND on mobile */}
                        {(isSimilarClusters && isMobile)? (
                          <div className={clxs.startFrom}>
                            Start from
                            {/* Show strikethrough price if discounted */}
                            {isShowDiscountedPrice ? (
                              <span className={clxs.strike}>
                                {`${currency_symbol} ${rate.toLocaleString("en-IN")}`}
                              </span>
                            ) : null}
                          </div>
                        ) : null}
                      
                        {/* Show "Start from" section if NOT a similar cluster */}
                        {!isSimilarClusters ? (
                          <div className={clxs.startFrom}>
                            Start from
                            {/* Show strikethrough price if discounted */}
                            {isShowDiscountedPrice? (
                              <span className={clxs.strike}>
                                {`${currency_symbol} ${rate.toLocaleString("en-IN")}`}
                              </span>
                            ) : null}
                          </div>
                        ): null}
                      
                        {/* Final price section - common for all */}
                        <div className={clxs.rateContainer}>
                          <span className={clxs.rate}>
                            {`${currency_symbol} ${finalPrice.toLocaleString("en-IN")}`}
                          </span>
                          <span className={clxs.excludingTax}>
                            {isMobile ? "/night*" : "/ night excluding taxes*"}
                          </span>
                        </div>
                      </div>
                      
                      {/* Total payable section only for similar clusters */}
                      {isSimilarClusters ? (
                        <div className={clxs.totalPayable}>
                          Total: {currency_symbol}{total_rate.toLocaleString("en-IN")}
                        </div>
                      ): null}
                      
                    </div>

                      <img
                        src={CHEVRON_RIGHT_GREY}
                        alt="isprava-built"
                        className={clxs.rightIcon}
                      />
                  </a>
                </Track>
              </Item>
            );
          },
        )}
      </Carousel>
      {listToRender.length > 3  &&
      <Scroller
        className={clxs.scroller}
        onScrollLeft={scrollLeft}
        onScrollRight={scrollRight}
        isLeftDisabled={leftCount === 0}
        isRightDisabled={rightCount === 0}
        isSmallIcon = {true}
      />}
    </div>
  );
}

export default Recommendation;
